import {useContext} from 'react';
import {IConsultaiAppContext} from '../interfaces/IConsultaiAppContext';
import ConsultaiAppContext from "../consultai-app-context";

export const useConsultaiAppContext = (): IConsultaiAppContext => {
    const context = useContext(ConsultaiAppContext);
    return {loading: context?.loading, setLoading: context?.setLoading};
};